export const CONTENT_TYPE = {
    PLAIN_TEXT: 'plainText',
    AT: 'at',
    EMOTICON: 'emoticon',
};

// @ts-ignore
export function createEmoticon(code, url) {
    return {
        type: CONTENT_TYPE.EMOTICON,
        url,
        code,
    };
}

// @ts-ignore
export function createPlainText(value) {
    return {
        type: CONTENT_TYPE.PLAIN_TEXT,
        value,
    };
}
